import React, { useEffect, useState } from 'react';
import { useTheme, ITheme } from 'src/theme';
import { css } from '@linaria/core';
import { useAvivaSelector } from '@redux/hook';
import { SQSPocketResponse } from '@models/MLTC/SQSPocketRequest.model';
import { GAAviva } from '@utils/gaAviva';
import { Helpers } from '@utils/helpers';
import { styled } from '@linaria/react';
import { IContactInfo } from '@static/contact-information';
import { isEmpty } from 'lodash';

import { LeftGrid, FullGrid, ContainerGrid, Container } from '@components/LayoutGrid';
import ContainerBlock from '@components/ContainerBlock';
import Heading from '@components/Heading';
import Text from '@components/Text';
import Listing from '@components/Listing';
import ContactBox from '@components/ContactBox';
import Divider from '@components/Divider';
import Link from '@components/Link';



interface StyledProps {
  theme?: ITheme;
  variant: 'default' | 'alternate-color' | 'dash' | 'table';
  margin?: string | number;
  marginItems?: string | number;
}

const fluidBox = css`
  margin-top: -40px;
`;
const marginTop = css`
  @media screen and (min-width: 768px) {
    margin-top: 30px
  }
`;
const Row = styled.div<StyledProps>`  
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: ${props => props.variant === 'dash' ? '15px' : '8px'} ${props => props.variant === 'default' ? '0' : props.variant === 'table' ? 0 : '20px'};
  box-sizing: border-box;
  justify-content: space-between;
  border-bottom: ${props => props.variant === 'dash' ? `1px solid ${props.theme?.colors.grey[700]}` : 'unser'};
  margin: ${props => typeof props.marginItems === 'number' ? `${props.marginItems || 0}px` : props.marginItems || 0};
  &:nth-child(odd) {
    background-color: ${props => props.variant === 'alternate-color' ? props.theme?.colors.grey[600] : 'unset'};
  }
  &:nth-child(even) {
    background-color: ${props => props.variant === 'alternate-color' ? props.theme?.colors.white + '' : 'unset'};
  }
  &:last-child {
    border-bottom: ${props => props.variant === 'dash' ? `none` : 'unser'};
  }
`
const Col = styled.div<StyledProps>`
  width: ${props => props.variant === 'dash' ? '50%' : 'auto'};
  margin: ${props => props.margin || 0};
  flex-grow: 1;
`

const alignRight = css`
  text-align: right;
`

export interface ThankYouProps { }

const trackOnload = (): void => {
  const GA = GAAviva.getInstance();
  let { form } = GA.digitalData;
  form.name = "";
  GA.trackPageLoad({ form });
}

const contactInformation_ML02: IContactInfo[] = [
  {
    label: 'Email',
    value: 'arc@singlife.com',
    type: 'email'
  },
  {
    label: 'WhatsApp',
    value: '+65 9238 7393',
    type: 'phone'
  },
  {
    label: 'Mondays to Fridays:',
    value: '8.45am to 5.30pm',
    type: 'other'
  },
  {
    label: 'Saturdays, Sundays & Public Holidays: ',
    value: 'Closed',
    type: 'other'
  }
];

function ThankYou(props: ThankYouProps) {

  const campaignDetail = useAvivaSelector(state => state.loading.campaignDetail); 
  const contactInformation = useAvivaSelector(state => state.staticData.contactInformation);
  const quoteRawResponse = useAvivaSelector(state => state.mltcStep1.quoteRawResponse);
  const basicDetails = useAvivaSelector(state => state.mltcStep1.basicDetails);
  const premiumPaymentMethod = useAvivaSelector(state => state.mltcStep5.premiumPaymentMethod);
  // const step = useAvivaSelector(state => state.mltcStep5.);
  const policyNo = useAvivaSelector(state => state.mltcStep5.policyNo);
  const [summaries, setSummaries] = useState<any>(undefined);
  const [campaignCode, setCampaignCode] = useState<string>('MLO1');

  const theme: ITheme = useTheme();
  useEffect(() => {
    console.log('QnB ➤ ThankYou ➤ useEffect() ➤', { campaignDetail });
    if (campaignDetail) {
      setCampaignCode(campaignDetail?.code);
    }

    if (!isEmpty(basicDetails)) {
      const { month, day, year } = basicDetails?.dob || { month: '', day: '', year: '' };
      const stringDate = `${month}/${day}/${year}`;
      const age = Helpers.getAge(new Date(stringDate));
      if (quoteRawResponse) {
        const quotation: SQSPocketResponse = new SQSPocketResponse(quoteRawResponse, age);
        if (summaries === undefined && quoteRawResponse) {
          let planDetails = [...quotation.mltcSummary.filter(o => !o.reviewOnly)]
          const premium = planDetails[planDetails.length - 1];
          planDetails[planDetails.length - 1] = { ...premium }
          const data = [
            { text: 'Policy number', value: policyNo },
            ...planDetails,
            // { text: 'Premium payment method', value: 'Credit Card<br>cc', fontWeight: 'bold' }
          ]
          setSummaries(data);
          trackOnload();
        }
      }
    }
    Helpers.clearCached();
  }, [quoteRawResponse, summaries, setSummaries, setCampaignCode, policyNo])
  return (
    <Container>
      <ContainerBlock className={fluidBox} background={theme.colors.secondary} padding="40px 0" paddingTablet="130px 0 110px 30px">
        <ContainerGrid>
          <FullGrid>
            <LeftGrid>
              <Heading fontWeight={600} color={theme.colors.white} margin="0 0 10px">Thank you! </Heading>
              <Text fontSize={theme.fontSize.label} fontWeight={300} color={theme.colors.white}>Your application has been successfully submitted. We’ll notify you on the status of your application within 5 working days.</Text>
            </LeftGrid>
          </FullGrid>
        </ContainerGrid>
      </ContainerBlock>
      <ContainerGrid>
        <LeftGrid>
          <div className={marginTop}></div>
          <Heading>Summary details</Heading>
          <Listing sources={summaries} variant="dash" margin="0px" />
          <Divider size={1} color={theme.colors.grey[700]} margin="0 0 15px" />
          <ContainerBlock marginTablet={'-10px 0 10px'}>
            <Row variant={'dash'}>
              <Col variant={'dash'} margin={'0 20px 0 0'}>
                <Text fontWeight={600}>Premium payment method</Text>
              </Col>
              <Col variant={'dash'} className={''}>
                <Text>
                  {premiumPaymentMethod?.cpfMediSaveAmount > 0 ? `CPF Medisave - ${Helpers.toCurrencyND(premiumPaymentMethod?.cpfMediSaveAmount)}` : ''}
                  {(premiumPaymentMethod?.cpfMediSaveAmount > 0 && premiumPaymentMethod.creditCardAmount > 0) && (<br />)}
                  {premiumPaymentMethod?.creditCardAmount > 0 ? `Credit Card - ${Helpers.toCurrencyND(premiumPaymentMethod?.creditCardAmount)}` : ''}                  
                </Text>
              </Col>
            </Row>
          </ContainerBlock>
          
          {/* <ContainerBlock padding="0 15px" paddingTablet="0 15px">
            <Heading variant="desc" margin="0px">* Premium payment term is equal to the policy term</Heading>
          </ContainerBlock> */}
          <Divider size={1} color={theme.colors.grey[700]} variant="dashed" margin="0 0 30px" />
          <Heading
            variant="sub"
            fontWeight={600}
            color={theme.colors.grey[400]}
          >
            Any questions related to your policy or complaints, please contact us:
          </Heading>
          <ContactBox items={(campaignCode === 'MLO2') ? contactInformation_ML02 : contactInformation} noDecorator={true} />
          <Text>Any claim matters, please visit <Link text='here' target="_blank" rel="noopener noreferrer" url='https://singlife.com/en/make-a-claim' /> where you can find out more on how to submit a claim.</Text>
        </LeftGrid>


      </ContainerGrid>
    </Container>
  );
};

export default ThankYou;
